
import { mdiChevronDown, mdiAccountCircle, mdiLogout } from '@mdi/js'

export default {
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    extended: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icons: {
        mdiChevronDown,
        mdiAccountCircle,
        mdiLogout
      }
    }
  },
  computed: {
    trameRef () {
      const poste = this.$user.profile.poste
      if (!poste) { return null }
      const scopes = { ddt: 'dept', dreal: 'region' }
      const code = poste === 'ddt' ? this.$user.profile.departement : this.$user.profile.region
      if (!code) { return null }

      return `${scopes[poste]}-${this.$options.filters.deptToRef(code)}`
    },
    dashboardRoute () {
      if (!this.$user.id) { return null }
      const { side, poste, departement, collectivite_id: collectiviteId } = this.$user.profile
      if (side === 'ppa') {
        return { name: 'ddt-departement-collectivites', params: { departement } }
      }
      if (side === 'etat') {
        return {
          name: poste === 'ddt' ? 'ddt-departement-collectivites' : 'trames-githubRef',
          params: { departement, githubRef: this.trameRef }
        }
      }
      if (side === 'collectivite') {
        return `/collectivites/${collectiviteId}`
      }
      return null
    },
    dashboardLabel () {
      const { side, poste } = this.$user.profile
      if (side === 'collectivite') { return 'Ma collectivité' }
      if (side === 'etat' && poste !== 'ddt') { return 'Trame régionale' }
      return 'Tableau de bord'
    }
  },
  async mounted () {
    await this.$user.isReady
  },
  methods: {
    async signOut () {
      const { error } = await this.$supabase.auth.signOut()
      if (error) {
        return
      }
      this.$router.push('/')
    }
  }
}
